angular.module('picmonicng').component('picmProgressBar', {
  templateUrl: '/templates/app/directives/picm-progress-bar/picm-progress-bar.html',
  bindings: {
    percent: '<',
    percent2: '<',
  },
  replace: true,
  controller: [
    function () {
      var $ctrl = this;

      $ctrl.cleanValues = function () {
        if ($ctrl.percent <= 0) {
          $ctrl.progress = 0;
        } else if ($ctrl.percent >= 100) {
          $ctrl.progress = 100;
        } else {
          $ctrl.progress = $ctrl.percent;
        }

        if ($ctrl.percent2 <= 0) {
          $ctrl.progress2 = 0;
        } else if ($ctrl.percent2 >= 100) {
          $ctrl.progress2 = 100;
        } else {
          $ctrl.progress2 = $ctrl.percent2;
        }
      };

      $ctrl.$onInit = function () {
        $ctrl.cleanValues();
      };

      $ctrl.$onChanges = function () {
        $ctrl.cleanValues();
      };
    },
  ],
});
